import React from 'react'

// Ladeanzeige der oeffentlichen Seiten: die handgeschriebene „4u" aus dem
// job4u-Logo zeichnet sich, verblasst und beginnt neu. Der Text bleibt
// sichtbar und sagt, was laedt; die Form ist Dekoration. data-state="loading"
// ist der Vertrag, auf den Tests und Screenshot-Suite warten. Gestaltung,
// verzoegertes Einblenden und die ruhige Fassung fuer prefers-reduced-motion
// stehen in scss/lib/_loadingIndicator.scss. immediate: ohne Verzoegerung
// einblenden — fuer ein Nachladen, bei dem die Seite schon steht und der
// Nutzer auf seine Eingabe hin eine Rueckmeldung erwartet.
const LoadingIndicator = ({ label, immediate = false }) => (
    <div className={`jm-loading${immediate ? ' is-immediate' : ''}`} role="status" data-state="loading">
        <svg className="jm-loading-swoosh" viewBox="0 0 60 46" aria-hidden="true" focusable="false">
            <path
                className="jm-loading-stroke-4u"
                pathLength="1"
                d="M11.7 2.5C6 11 2 20 4 25c1.5 3.5 5 4.5 9.5 4.5C21 29 30 25 37.5 21c-4.5 8-6.5 16-2.5 20 3.5 3.5 11 2 19-11-1 6-1 11 2.7 13.3"
            />
            <path className="jm-loading-stroke-bar" pathLength="1" d="M18 18c-1.5 8-2 17-1.5 25" />
        </svg>
        <span className="jm-loading-label">{label}</span>
    </div>
)

export default LoadingIndicator
